export default __webpack_public_path__ + "static/media/location.6e5f1e27.svg";